import React from "react";
import { useTranslation } from "react-i18next";

import { useRetrieveProjectsElementsTags } from "@planzone/view-models";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function sanitize(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function hashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();
  return "00000".substring(0, 6 - c.length) + c;
}

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
  return brightness > 155;
}

function Form(props: Props) {
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState("");
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    tags,
    retrieveProjectsElementsTags,
  } = useRetrieveProjectsElementsTags();
  const unUsedTags = tags.filter(
    (tag) => !props.tags.find(({ name }) => tag.name === name),
  );
  const filteredTags = unUsedTags.filter((tag) =>
    new RegExp(sanitize(formData), "i").test(tag.name),
  );

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectsElementsTags({});
  }, []);

  return (
    <div className={styles.form}>
      <form
        className={styles.main}
        onSubmit={(e) => {
          e.preventDefault();
          props.add({ name: formData });
        }}
      >
        <input
          type="text"
          className={styles.input}
          placeholder={t("listsList.tags.placeholder")}
          value={formData}
          onChange={({ target }) => setFormData(target.value)}
        />
        <Button
          className={styles.button}
          type="submit"
          isDisabled={formData.trim() === ""}
        >
          {t("listsList.tags.submit")}
        </Button>
      </form>
      {unUsedTags.length > 0 && (
        <ul className={styles.list}>
          {filteredTags.map((tag) => {
            const color = `#${intToRGB(hashCode(tag.name))}`;
            const textColor = isColorLight(color) ? "#000000" : "#FFFFFF";
            return (
              <li
                key={tag.name}
                className={styles.item}
                onClick={() => props.add(tag)}
              >
                <span
                  className={styles.tagBadge}
                  style={{ backgroundColor: color, color: textColor }}
                >
                  {tag.name}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export { Form };
